import axios from 'axios'
import router from '@/router'

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:8000/api/v1'

export default {
  namespaced: true,
  state: {
    token: null,
    isLoggedIn: false,
    currentUser: null,
    loading: false,
    error: null
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      state.isLoggedIn = !!token
    },
    SET_CURRENT_USER(state, user) {
      state.currentUser = user
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    LOGOUT(state) {
      state.token = null
      state.isLoggedIn = false
      state.currentUser = null
    }
  },
  actions: {
    async login({ commit, dispatch }, credentials) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      
      try {
        // Formato de FormData para la autenticación OAuth2
        const formData = new FormData()
        formData.append('username', credentials.email)
        formData.append('password', credentials.password)
        
        const response = await axios.post(`${API_URL}/login/access-token`, formData)
        const token = response.data.access_token
        
        // Guardar token
        localStorage.setItem('token', token)
        commit('SET_TOKEN', token)
        
        // Configurar axios para incluir el token en las solicitudes futuras
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
        
        // Obtener información del usuario
        await dispatch('fetchCurrentUser')
        
        // Redireccionar según el rol
        if (this.state.auth.currentUser.is_admin) {
          router.push({ name: 'dashboard' })
        } else {
          router.push({ name: 'upload' })
        }
        
        return true
      } catch (error) {
        console.error('Error de inicio de sesión:', error)
        commit('SET_ERROR', error.response?.data?.detail || 'Error al iniciar sesión')
        return false
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    async fetchCurrentUser({ commit }) {
      try {
        const response = await axios.post(`${API_URL}/login/test-token`)
        commit('SET_CURRENT_USER', response.data)
      } catch (error) {
        console.error('Error al obtener usuario:', error)
        localStorage.removeItem('token')
        commit('LOGOUT')
        router.push({ name: 'login' })
      }
    },
    
    setToken({ commit }, token) {
      // Configurar axios para usar el token
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
      commit('SET_TOKEN', token)
      
      // Obtener información del usuario
      this.dispatch('auth/fetchCurrentUser')
    },
    
    logout({ commit }) {
      localStorage.removeItem('token')
      delete axios.defaults.headers.common['Authorization']
      commit('LOGOUT')
      router.push({ name: 'login' })
    }
  },
  getters: {
    isAdmin(state) {
      return state.currentUser?.is_admin || false
    }
  }
} 